<template>
	<!-- 堆积柱状图 堆积条形图 雷达图 -->
	<!-- 矩阵单选   -->
	<div class="matrixChart">
		<div class="title_box">
			<span class="title_box_span">
				<span class="textlong" :title="htmlToString(CrossTabs.name)">
					<span>{{ CrossTabs.sheet }}:</span>
					{{ htmlToString(CrossTabs.name) }}
				</span>
			</span>
			<span class="el-dropdown_button">
				<el-button v-if="bankAnalysis==2" plain style="margin-top: 10px; margin-right: 10px" @click="newExport(CrossTabs.id)">{{$t('DataRecycling.ExportData')}}</el-button>
				<el-button plain style="margin-top: 10px; margin-right: 10px" @click="exportExcl(CrossTabs.id)">{{$t('DataRecycling.ExportChart')}}</el-button>
				<el-select :popper-append-to-body="false" v-model="CrossTabs.chartType" :placeholder="$t('DataRecycling.PleaseSelect')" :key="CrossTabs.id" @change="selection">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</span>
		</div>
		<div class="echartBox"><div class="echart" ref="echart_div"></div></div>
		<div class="">
			<table border="1">
				<tr v-for="(item1, index1) in newCrossTabsList" :key="index1" class="table_tr">
					<td v-for="(item2, index2) in item1" :key="index2" class="table_tr">{{ htmlToString(item2) }}</td>
				</tr>
				<tr>
					<td colspan="100">{{$t('DataRecycling.NumberOfRespondents')}} : {{ CrossTabs.answerNumber }}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import echarts from 'echarts';
export default {
	props: {
		CrossTabs: {
			type: Object //可指定接收类型，如:Array.
		},
		bankAnalysis: {
			type: Number //可指定接收类型，如:Number.
		},
		CrossTabsindex: {}
	},
	data() {
		return {
			wid: 0,
			seriesData: [],
			legendData: [], //矩阵的说明
			cumulateSeries: [], //矩阵数据
			newCrossTabsList: [],
			options: [
				{
					value: '6',
					label: this.$t('DataRecycling.StackedColumnChart')
				},
				{
					value: '7',
					label: this.$t('DataRecycling.StackedBarChart')
				},
				{
					value: '8',
					label: this.$t('DataRecycling.RadarChart')
				},
				{
					value: '9',
					label: this.$t('DataRecycling.StackedColumnChart')
				},
				{
					value: '10',
					label: this.$t('DataRecycling.StackedBarChart')
				}
			]
		};
	},
	mounted() {
		this.wid = sessionStorage.getItem('wid') || 0;
		this.loadData();
		console.log('this.CrossTabs :>> ', this.CrossTabs);
	},
	methods: {
		newExport(id){
			this.$emit('newExport',id)
		},
		exportExcl(qid) {
			var id = this.wid;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.exportTopicStatistics}?id=${id}&state=0&Authorization=Bearer${window.localStorage.getItem('token')}&qid=${qid}&isbank=${
					that.CrossTabs.isbank
				}`,
				method: 'Get',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.popUpPrompt()
					} else {
						that.$message.warning(res.message);
					}
				}
			};
			this.$util.request(params);
		},
				popUpPrompt() {
			this.$notify({
				dangerouslyUseHTMLString: true,
				message: `${this.$t('DataRecycling.DataPreparationInProgress')} 
							<a href="#" class="notify-link" id="my-download-link">
								<span style="color: blue;">${this.$t('DataRecycling.MyDownload')}</span>
							</a> 
							${this.$t('DataRecycling.CanViewProgress')}`
			});
			this.$nextTick(() => {
				const link = document.querySelector('#my-download-link');
				if (link) {
					link.addEventListener('click', (e) => {
						e.preventDefault(); // 阻止默认的链接跳转
						this.$router.push('/MyProject'); // 使用 Vue Router 跳转
					});
				}
			});
		},
		htmlToString(htmlStr) {
			return htmlStr.replace(/<\/?.+?\/?>|\r|\n*/g, '');
		},
		selection(val) {
			this.seriesData = [];
			this.legendData = [];
			this.cumulateSeries = [];
			if (val == 6) {
				this.cumulateCol();
			}
			if (val == 7) {
				this.cumulateBar();
			}
			if (val == 8) {
				this.radar();
			}
			if (val == 9) {
				this.stackedColumnDiagram();
			}
			if (val == 10) {
				this.stackBarCharts();
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setStatisticalStyle}`,
				method: 'POST',
				data: {
					id: that.CrossTabs.id,
					chartType: val,
					isBank: that.CrossTabs.isbank
				},
				cb(res) {
					if (res.code == 0) {
					}
				}
			};
			this.$util.request(params);
		},
		stackedColumnDiagram() {
			let targetArr = JSON.parse(JSON.stringify(this.CrossTabs.dataArrayList));
			this.legendData = targetArr[0];
			let temporaryindicator = [];
			for (let i = 0; i < targetArr[0].length; i++) {
				let seriesList = {}; //系列数据
				seriesList.name = targetArr[0][i];
				seriesList.type = 'bar';
				seriesList.data = []; //x轴数据
				for (let l = 2; l < targetArr.length; l++) {
					seriesList.data.push(targetArr[l][i]); //x轴数据
				}
				this.cumulateSeries.push(seriesList);
			}
			let X = targetArr[1];
			let namenum = Math.floor(100 / (X.length / 7)); //  这个5  可以顺便调整    是用来判断当前视图要显示几个
			if (X.length > 6) {
				//  6也可以调整     用来判断是否显示滚动条
				var showEchart = true;
			} else {
				var showEchart = false;
			}
			console.log(this.cumulateSeries);
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				tooltip: {
					trigger: 'axis'
				},
				legend: {
					data: this.legendData
				},
				toolbox: {
					show: false,
					feature: {
						dataView: { show: true, readOnly: false },
						magicType: { show: true, type: ['line', 'bar'] },
						restore: { show: true },
						saveAsImage: { show: true }
					}
				},
				calculable: true,
				xAxis: [
					{
						type: 'category',
						// prettier-ignore
						data: targetArr[1],
						axisLabel: {
							interval: 0,// 横坐标文字默认会间隔显示，设置0 就全部显示出来了
							//多出字可以省略显示成点
							formatter: function (params){
								var index = 10; //字数为6个超出就显示成点
								var newstr = '';
								for(var i = 0; i< params.length; i += index){
									var tmp = params.substring(i, i+index);
									newstr += tmp +'';
								}
								if( newstr.length > 10)
									return newstr.substring(0, 10) + '...';
								else
									return '\n'+newstr;
							},
						}
					}
				],
				yAxis: [
					{
						type: 'value'
					}
				],
				series: this.cumulateSeries,
				dataZoom: [
					//   这是滚动条
					{
						show: showEchart, // 是否展示
						xAxisIndex: [0], // 控制第一个x轴
						height: 20,
						left: 100,
						right: 100,
						bottom: 0,
						start: 0, // 数据窗口范围的起始百分比。范围是：0 ~ 100。表示 0% ~ 100%。
						end: namenum, // 数据窗口范围的结束百分比。范围是：0 ~ 100。
						handleSize: '110%',
						zoomLock: false //是否锁定选择区域（或叫做数据窗口）的大小。如果设置为 true
					}
				]
			};
			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		stackBarCharts() {
			let targetArr = JSON.parse(JSON.stringify(this.CrossTabs.dataArrayList));
			this.legendData = targetArr[0];
			let temporaryindicator = [];
			for (let i = 0; i < targetArr[0].length; i++) {
				let seriesList = {}; //系列数据
				seriesList.name = targetArr[0][i];
				seriesList.type = 'bar';
				seriesList.data = []; //x轴数据
				for (let l = 2; l < targetArr.length; l++) {
					seriesList.data.push(targetArr[l][i]); //x轴数据
				}
				this.cumulateSeries.push(seriesList);
			}
			let X = targetArr[1];
			let namenum = Math.floor(100 / (X.length / 7)); //  这个5  可以顺便调整    是用来判断当前视图要显示几个
			if (X.length > 6) {
				//  6也可以调整     用来判断是否显示滚动条
				var showEchart = true;
			} else {
				var showEchart = false;
			}
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				legend: {
					data: targetArr[0]
				},
				grid: {
					left: '3%',
					right: '5%',
					bottom: '3%',
					containLabel: true
				},
				yAxis: {
					type: 'category',
					data: targetArr[1]
				},
				xAxis: {
					type: 'value'
				},
				series: this.cumulateSeries,
				dataZoom: [
					//   这是滚动条
					{
						show: showEchart, // 是否展示
						yAxisIndex: [0], // 控制第一个x轴
						filterMode: 'filter',
						bottom: 30,
						start: 0, // 数据窗口范围的起始百分比。范围是：0 ~ 100。表示 0% ~ 100%。
						end: namenum, // 数据窗口范围的结束百分比。范围是：0 ~ 100。
						handleSize: '110%',
						zoomLock: false //是否锁定选择区域（或叫做数据窗口）的大小。如果设置为 true
					}
				]
			};
			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		// 堆积 条形图
		cumulateBar() {
			let targetArr = JSON.parse(JSON.stringify(this.CrossTabs.dataArrayList));
			this.legendData = targetArr[0];
			let temporaryindicator = [];
			for (let i = 0; i < targetArr[0].length; i++) {
				let seriesList = {}; //系列数据
				seriesList.name = targetArr[0][i];
				seriesList.type = 'bar';
				seriesList.stack = 'total';
				seriesList.label = { show: true };
				seriesList.emphasis = { focus: 'series' };
				seriesList.data = []; //x轴数据
				for (let l = 2; l < targetArr.length; l++) {
					seriesList.data.push(targetArr[l][i]); //x轴数据
				}
				this.cumulateSeries.push(seriesList);
			}
			let X = targetArr[1];
			let namenum = Math.floor(100 / (X.length / 7)); //  这个5  可以顺便调整    是用来判断当前视图要显示几个
			if (X.length > 6) {
				//  6也可以调整     用来判断是否显示滚动条
				var showEchart = true;
			} else {
				var showEchart = false;
			}
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				legend: {
					data: targetArr[0]
				},
				grid: {
					left: '3%',
					right: '5%',
					bottom: '3%',
					containLabel: true
				},
				yAxis: {
					type: 'category',
					data: targetArr[1]
				},
				xAxis: {
					type: 'value'
				},
				series: this.cumulateSeries,
				dataZoom: [
					//   这是滚动条
					{
						show: showEchart, // 是否展示
						yAxisIndex: [0], // 控制第一个x轴
						filterMode: 'filter',
						bottom: 30,
						start: 0, // 数据窗口范围的起始百分比。范围是：0 ~ 100。表示 0% ~ 100%。
						end: namenum, // 数据窗口范围的结束百分比。范围是：0 ~ 100。
						handleSize: '110%',
						zoomLock: false //是否锁定选择区域（或叫做数据窗口）的大小。如果设置为 true
					}
				]
			};
			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		// 堆积柱状图
		cumulateCol() {
			let targetArr = JSON.parse(JSON.stringify(this.CrossTabs.dataArrayList));
			this.legendData = targetArr[0];
			let temporaryindicator = [];
			for (let i = 0; i < targetArr[0].length; i++) {
				let seriesList = {}; //系列数据
				seriesList.name = targetArr[0][i];
				seriesList.type = 'bar';
				seriesList.stack = 'total';
				seriesList.label = { show: true };
				seriesList.emphasis = { focus: 'series' };
				seriesList.data = []; //x轴数据
				for (let l = 2; l < targetArr.length; l++) {
					seriesList.data.push(targetArr[l][i]); //x轴数据
				}
				this.cumulateSeries.push(seriesList);
			}
			let X = targetArr[1];
			let namenum = Math.floor(100 / (X.length / 7)); //  这个5  可以顺便调整    是用来判断当前视图要显示几个
			if (X.length > 6) {
				//  6也可以调整     用来判断是否显示滚动条
				var showEchart = true;
			} else {
				var showEchart = false;
			}
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				legend: {
					data: targetArr[0]
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '10%',
					containLabel: true
				},
				yAxis: {
					type: 'value'
				},
				xAxis: {
					type: 'category',
					data: targetArr[1],
					axisLabel: {
						interval: 0,// 横坐标文字默认会间隔显示，设置0 就全部显示出来了
						//多出字可以省略显示成点
						formatter: function (params){
							var index = 10; //字数为6个超出就显示成点
							var newstr = '';
							for(var i = 0; i< params.length; i += index){
								var tmp = params.substring(i, i+index);
								newstr += tmp +'';
							}
							if( newstr.length > 10)
								return newstr.substring(0, 10) + '...';
							else
								return '\n'+newstr;
						},
					}
				},
				series: this.cumulateSeries,
				dataZoom: [
					//   这是滚动条
					{
						show: showEchart, // 是否展示
						xAxisIndex: [0], // 控制第一个x轴
						height: 20,
						left: 100,
						right: 100,
						bottom: 0,
						start: 0, // 数据窗口范围的起始百分比。范围是：0 ~ 100。表示 0% ~ 100%。
						end: namenum, // 数据窗口范围的结束百分比。范围是：0 ~ 100。
						handleSize: '110%',
						zoomLock: false //是否锁定选择区域（或叫做数据窗口）的大小。如果设置为 true
					}
				]
			};
			getchart.clear();
			getchart.setOption(option);
			// //随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		// 雷达图
		radar() {
			let targetArr = JSON.parse(JSON.stringify(this.CrossTabs.dataArrayList));
			this.legendData = targetArr[0];
			let temporaryindicator = [];
			for (let i = 0; i < targetArr[0].length; i++) {
				let seriesList = {}; //系列数据
				seriesList.name = targetArr[0][i];
				// seriesList.type = 'radar';
				// seriesList.stack = 'total';
				// seriesList.label = { show: true };
				// seriesList.emphasis = { focus: 'series' };
				seriesList.value = []; //x轴数据
				for (let l = 2; l < targetArr.length; l++) {
					seriesList.value.push(targetArr[l][i]); //x轴数据
				}
				this.cumulateSeries.push(seriesList);
			}
			let radarIndicator = [];
			targetArr[1].forEach(item => {
				let obj = {
					name: item
				};
				radarIndicator.push(obj);
			});
			console.log('legend', targetArr[0]);
			console.log('radar', radarIndicator);
			console.log('series', this.cumulateSeries);
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				legend: {
					orient: 'vertical',
					x: 'left', //可设定图例在左、右、居中
					y: 'center', //可设定图例在上、下、居中
					padding: [0, 0, 0, 0],
					data: targetArr[0]
				},
				radar: {
					// shape: 'circle',
					indicator: radarIndicator
				},
				grid: {
					// top,bottom,left,right等
					top: '3%',
					left: '3%',
					right: '4%',
					bottom: '',
					containLabel: true
				},
				series: [
					{
						name: '',
						type: 'radar',
						// areaStyle: {normal: {}},
						data: this.cumulateSeries
					}
				]
			};
			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		loadData() {
			// 取饼图  圆环图数据
			this.selection(this.CrossTabs.chartType || '6');
			let newCrossTabsList = JSON.parse(JSON.stringify(this.CrossTabs.dataArrayList));
			let newLeaber = newCrossTabsList.splice(1, 1);
			newLeaber = newLeaber[0];
			newLeaber.unshift('');
			for (let i = 0; i < newCrossTabsList.length; i++) {
				newCrossTabsList[i].unshift(newLeaber[i]);
			}
			this.newCrossTabsList = newCrossTabsList;
		}
	}
};
</script>

<style scoped="scoped" lang="scss">
.matrixChart {
	.title_box {
		width: 100%;
		height: 56px;
		background: #f9fcff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.title_box_span {
			margin-left: 25px;
			font-size: 14px;
			color: #000;
			font-family: Microsoft YaHei;
			width: calc(100% - 300px);
		}
		.el-dropdown_button {
			float: right;
			margin-right: 20px;
		}
	}
	.echartBox {
		width: 100%;
		height: 400px;
		margin-top: 20px;
		overflow-y: auto;
		.echart {
			width: 90%;
			height: 400px;
			margin: 0px auto;
		}
	}
	table {
		width: 90%;
		margin: 0 auto;
		border: 1px solid #dbdada;
		margin-bottom: 20px;
		border-collapse: collapse;
		border-spacing: 0;
		margin-top: 20px;
	}

	table tr td {
		padding: 8px 0 8px 10px;
	}
}
</style>
